<template>
  <div class="helmholtz-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>f = (v/2π)·√(A/VL) | 空腔共鸣$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Bottle / Resonator -->
          <!-- Neck -->
          <rect :x="185" y="40" width="30" :height="neckLength" fill="none" stroke="#888" stroke-width="2" />
          <!-- Body -->
          <rect :x="150" :y="40 + neckLength" width="100" :height="bodySize" fill="none" stroke="#22a6b3" stroke-width="2" rx="10" />
          
          <!-- Air concentration (Vibrating slug in neck) -->
          <rect :x="186" :y="45 + neckLength/2 + osc" width="28" :height="neckLength/2" fill="#ffd700" opacity="0.6" />

          <!-- Pressure waves in body -->
          <circle v-for="i in 3" :key="i" cx="200" :cy="40 + neckLength + bodySize/2" :r="10 + i*15 + osc*2" 
                  fill="none" stroke="rgba(34, 166, 179, 0.3)" stroke-width="2" />

          <!-- Airflow label -->
          <path d="M 120,40 Q 150,30 185,45" fill="none" stroke="#fff" stroke-dasharray="2,2" />
          <text x="80" y="30" fill="#fff" font-size="8">掠过瓶口的空气</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>共振频率: {{ frequency.toFixed(1) }} Hz</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>瓶身容积</label>
             <el-slider v-model="bodySize" :min="40" :max="120" size="mini"></el-slider>
          </div>
          <div class="row items-center mt-2">
             <label>瓶颈长度</label>
             <el-slider v-model="neckLength" :min="10" :max="60" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>赫姆霍兹共振是指空气在容器内共鸣的现象。与管乐器的驻波不同，这里的空气被看作一个**弹簧-质量系统**：瓶颈处的空气柱像一个“活塞（质量）”，而瓶身内的空气像一个“弹簧（弹性）”。当你朝瓶口吹气，质量块震动并压缩弹簧，产生特定频率的共鸣。这被用于音箱倒相孔设计、汽车排气消音器以及吉他的琴身设计中。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelmholtzResonatorViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      bodySize: 80,
      neckLength: 30,
      t: 0,
      timer: null
    }
  },
  computed: {
    frequency() {
       // f ~ sqrt(1 / (V * L))
       return 2000 / Math.sqrt(this.bodySize * this.neckLength);
    },
    osc() {
       return Math.sin(this.t * 0.2) * 5;
    }
  },
  methods: {
    animate() {
       this.t += 1;
       this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.helmholtz-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(34, 166, 179, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
